import h from 'react-hyperscript';
import List from 'Components/List/List';
import {OverviewDetail} from './AccordionItem';


export default function AccordianContentMinimal({item, alternateResources}) {
  return h('div', {className: 'row'}, [
    h('div', {
      className: 'flex--half minimal--overview-detail',
    }, h(OverviewDetail, {item})),
    h(List, {
      className: 'flex--half margin-top--md-2',
      title: `Recommended resources for ${item.title}`,
      items: alternateResources,
    }),
  ]);
}
